/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown>, position: NonNullable<unknown>, name: NonNullable<unknown> }} Agenda_Card_LinkInputs */



/**
* | output |
* | --- |
* | "{title} — link to step {position} of {name}" |
*
* @param {Agenda_Card_LinkInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_card_link = /** @type {((inputs: Agenda_Card_LinkInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Card_LinkInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.title} — koppel aan stap ${i?.position} van ${i?.name}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.title} — associer à l'étape ${i?.position} de ${i?.name}`)
	return /** @type {LocalizedString} */ (`${i?.title} — link to step ${i?.position} of ${i?.name}`)
});